import Evented from './mixins/evented';
import Deferred from './mixins/deferred';

const app = {};

_extend.call(app, Evented);
_extend.call(app, Deferred);

export default 'Voonto' in window ? Voonto.getInstance() : app;

/* Private */

function _extend(source) {
  Object.keys(source).forEach((key) => {
    this[key] = source[key];
  });

  return this;
}



// WEBPACK FOOTER //
// ./src/application.js